// extracted by css-extract-rspack-plugin
export default {"cls1":"Instructor-cls1_EYf","cls2":"Instructor-cls2_8Cd Instructor-cls1_EYf"};